
function createFlickityNav() {
  // Create the navigation wrapper
  var $nav = $('<div class="flickity-nav" id="featured-nav"></div>');
  var $content = $('.anchor.collection .h2.featured_title');
  // Find each featured title and create a nav cell
  $content.each(function() {
    var titleId = $(this).attr('id');
    var titleText = $(this).text();
    var $cell = $('<div class="nav-cell" data-target="' + titleId + '">' + titleText + '</div>');
    $nav.append($cell);
  });
if($('.anchor.collection').length){
  // Insert the navigation above .anchor.collection
  $('.shopify-section--header').append($nav);
} 
 if ($content.length == 0 ){
   $nav.remove();
   $('.shopify-section--header').addClass('no-flick-nav');
 } else{
   $('.shopify-section--header').addClass('flick-nav');
 }
}

$(document).ready(function() {
  // Dynamically create the navigation
  createFlickityNav();

  if($('.flickity-nav')){
    
  // Initialize Flickity on the dynamically created navigation
  $('.flickity-nav').flickity({
    // Flickity options
selectedAttraction: 0.01,
friction: 0.15,
    cellAlign: 'left',
    pageDots: false,
    prevNextButtons: false
  });

  // Scroll to section on navigation click
  $('.nav-cell').on('click', function() {
    var targetId = $(this).data('target');
    var targetPosition = $('#' + targetId).offset().top - 150;

    $('html, body').animate({
      scrollTop: targetPosition
    }, 1000); // Adjust duration as needed
  });

    const flickityInstance = $('.flickity-nav').data('flickity');
  // Update active navigation based on scroll
   $(window).on('scroll', function() {
      let nearestSectionId = '';
      let nearestSectionDistance = Number.MAX_VALUE;
  
      $('.h2.featured_title').each(function() {
          const topOfWindow = $(window).scrollTop();
          const sectionTop = $(this).offset().top - 50; // Consider any offset like a fixed header
          const distance = Math.abs(topOfWindow - sectionTop);
  
          // Find the nearest section above the current scroll position
          if (distance < nearestSectionDistance) {
              nearestSectionDistance = distance;
              nearestSectionId = $(this).attr('id');
          }
      });
  
      if (nearestSectionId !== '') {
                const $navCells = $('.nav-cell');
      const selectedIndex = $navCells.filter(`[data-target="${nearestSectionId}"]`).index();
      
      // Use Flickity's selectCell method to ensure the selected nav cell is visible in the viewport
      // This will also trigger the 'select' event and update the active class
      flickityInstance.selectCell(selectedIndex, false, true);
      }
  });
  }
});



document.addEventListener('mouseover', function(event) {
  // Check if the hovered element is inside .kt-tooltip-inner or is .kt-tooltip-inner itself
  let tooltipInner = event.target.closest('.kt-tooltip-inner');

  // If .kt-tooltip-inner was found in the path of the event
  if (tooltipInner) {
    // Select all links within the hovered .kt-tooltip-inner element
    const links = tooltipInner.querySelectorAll('a');

    // Loop through each link and add target="_blank" if it doesn't already have it
    links.forEach(function(link) {
      if (!link.hasAttribute('target')) {
        link.setAttribute('target', '_blank');
      }
    });
  }
});


